import { render, staticRenderFns } from "./UserUsageTraineeUserCorrectAnswerRateTable.vue?vue&type=template&id=0af506ae&"
import script from "./UserUsageTraineeUserCorrectAnswerRateTable.vue?vue&type=script&lang=ts&"
export * from "./UserUsageTraineeUserCorrectAnswerRateTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports